import {Component} from "../../../gvf/js/component";

export class TaskRunProgressBar extends Component{
    constructor(scope,$root){
        super(scope,$root);
    }

    setProgress(progress,progressStatus){
        const $bar = this.findMember("bar");
        $bar.css("width",progress+"%");
        $bar.toggleClass("progress-bar-animated",progress<100);
        $bar.toggleClass("bg-success",progress==100);
        $bar.html(progress+"%");
        this.findMember("status").html(progressStatus);
    }
}

